import { render, staticRenderFns } from "./inboxlist.vue?vue&type=template&id=2e327d66&"
import script from "./inboxlist.vue?vue&type=script&lang=js&"
export * from "./inboxlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports